import Vue from "vue";

const ALLOWED = ["summary", "topics", "dynamics", "posts"];

try {
  localStorage.removeItem("cmHiddenSections");
} catch (e) {}

export const hiddenStore = Vue.observable({ ids: [] });

export function toggleSection(id) {
  if (ALLOWED.indexOf(id) === -1) return;
  const index = hiddenStore.ids.indexOf(id);
  if (index !== -1) hiddenStore.ids.splice(index, 1);
  else hiddenStore.ids.push(id);
}
